import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'list': [],
  'pageSize': 20,
  'pageNumber': 0,
  'itemsCount': 0,
};

export const prioritizationIndices = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_PRIORITIZATION_INDICES]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.FETCHING_PRIORITIZATION_INDICES]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_PRIORITIZATION_INDICES]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'itemsCount': action.response.count,
    }),
    [ActionTypes.FETCHED_PRIORITIZATION_INDICES_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
      'itemsCount': 0,
    }),
    [ActionTypes.CHANGE_PRIORITIZATION_INDICES_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
    }),
    [ActionTypes.CHANGE_PRIORITIZATION_INDICES_LIST_PAGE_SIZE]: (
      state,
      action
    ) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
    }),
    [ActionTypes.DOWNLOADING_PRIORITIZATION_INDICES]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES]: (state, action) => {
      downloadFile(action.response.data);

      return {
        ...state,
        'downloading': false,
      };
    },
    [ActionTypes.DOWNLOADED_PRIORITIZATION_INDICES_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'downloading': false,
    }),
  })(state, action);
};
